<template>
  <div class="home_doctor" data-testid="reception-dashboard">
    <div class="row justify-content-md-center">
      <div class="col-md-8">
        <visits></visits>
      </div>
      <div class="col-md-4">
        <tasks></tasks>
      </div>
    </div>
  </div>
</template>

<script>
  import Visits from './components/Visits.vue'
  import Tasks from './components/Tasks.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      Visits,
      Tasks
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/HomeReceptionist/HomeReceptionist.vue?638dc9a8